const TextLoading = ({ text }: { text: string }) => {
  return (
    <div className="text-loading-wrapper">
      <div className="loading-text">
        <h1 className="font-semibold">
          {text || 'Loading'}
          <span className="dot dot-one">.</span>
          <span className="dot dot-two">.</span>
          <span className="dot dot-three">.</span>
        </h1>
      </div>
    </div>
  )
}

export default TextLoading
